/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, bool, string, func,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as Joi from 'joi-browser';
import withStyles from '@material-ui/core/styles/withStyles';

import Form from '../../../common/Form';
import { form as FormStyle } from '../../../style/form';
import ErrorInline from '../../../common/ErrorMessages/ErrorInline';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';

const { PERSIST_KEY } = configENV;
const styles = ({ typography, palette }) => FormStyle(typography, palette);

class DesktopChangeName extends Form {
    state = {
        data: {
            firstName: '',
            lastName: '',
        },
        isSubmited: false,
        errors: {},
    };

    schema = {
        firstName: Joi.string()
            .trim()
            .min(2)
            .max(20)
            .required()
            .label('First Name'),
        lastName: Joi.string()
            .trim()
            .min(2)
            .max(20)
            .required()
            .label('Last Name'),
    };

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const {
            firstName, lastName, firstNameUpdate, lastNameUpdate, buttonType,
        } = props;
        let { data } = this.state;
        if (buttonType === 'SubmitProfile') {
            if (data.firstName && data.lastName) {
                if (firstNameUpdate && lastNameUpdate) {
                    if (data.firstName !== firstNameUpdate || data.lastName !== lastNameUpdate) {
                        this.doSubmit();
                    }
                } else if (data.firstName !== firstName || data.lastName !== lastName) {
                    this.doSubmit();
                }
            }
        } else {
            data = {
                firstName: firstNameUpdate || firstName,
                lastName: lastNameUpdate || lastName,
            };
            this.setState({ isSubmited: false, data });
        }
    };

    doSubmit = () => {
        const { data, errors } = this.state;
        const { handleUpdateFirstnameLastname } = this.props;
        if (this.validate(true)) {
            this.setState({ isSubmited: true }, () => {
                handleUpdateFirstnameLastname(data);
            });
        } else {
            const { firstName, lastName } = this.validate();
            if (firstName) {
                errors.firstName = firstName;
            }
            if (lastName) {
                errors.lastName = lastName;
            }
        }
    };

    updateFirstAndLastNameForm = (props) => {
        // eslint-disable-next-line object-curly-newline
        const { isReadyState, classes } = props;
        const submitButtonLabel = isReadyState
            ? 'Update Password'
            : 'Updating...';
        return (
            <>
                <form
                    onSubmit={(event) => this.handleSubmit(event, {})}
                    className={`${classes.form} margin-bottom-2x`}
                    disabled={!isReadyState}
                >
                    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                    <ErrorInline {...props} name="updateFirstAndLastNameForm" />
                    <div className="split position-relative">
                        {this.renderInput({
                            name: 'firstName',
                            dataTest: { field: 'my-account-firstName' },
                            label: 'First Name *',
                            type: 'text',
                            length: 20,
                            desktop: true,
                        })}
                        {this.renderInput({
                            name: 'lastName',
                            label: 'Last Name *',
                            dataTest: { field: 'my-account-lastName' },
                            type: 'text',
                            length: 20,
                            desktop: true,
                        })}
                        <div />
                    </div>
                    {/* keep the submit button below to preven error from automation test */}
                    <div className="margin-top-2x opacity1 display-none">
                        {this.renderButton({
                            label: submitButtonLabel,
                            className: 'buttonHD',
                            dataTest: { field: 'my-account-submit' },
                            onClick: null,
                            type: 'submit',
                            isValidated: true,
                            isReadyState,
                        })}
                    </div>
                </form>
            </>
        );
    };

    continueShopping = (successMessage) => (
        <>
            <div data-test="my-account-change-password-success-text" className="">{successMessage}</div>
        </>
    );

    render() {
        // eslint-disable-next-line object-curly-newline
        const { status, template, successMessage } = this.props;
        return (
            <>
                {status === 'success' && template === 'updateFirstNameAndLastName' ? this.continueShopping(successMessage) : ''}
                {this.updateFirstAndLastNameForm(this.props)}
            </>
        );
    }
}

DesktopChangeName.defaultProps = {
    status: '',
    firstNameUpdate: '',
    lastNameUpdate: '',
    successMessage: '',
    buttonType: '',
    template: '',
    error: {},
};

DesktopChangeName.propTypes = {
    classes: object.isRequired,
    error: object,
    isReadyState: bool.isRequired,
    status: string,
    firstName: string.isRequired,
    lastName: string.isRequired,
    firstNameUpdate: string,
    lastNameUpdate: string,
    template: string,
    successMessage: string,
    buttonType: string,
    handleUpdateFirstnameLastname: func.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
        status: newState.status,
        buttonType: newState.buttonType,
        firstNameUpdate: newState.firstName,
        lastNameUpdate: newState.lastName,
        template: newState.template,
        successMessage: newState.successMessage,
        error: newState.error,
        toggleState: newState.toggleState,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleUpdateFirstnameLastname: (data) => dispatch(EventDispatcher.handleUpdateFirstnameLastname(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(DesktopChangeName)));
